import { apiDaInscricao } from "../../../servicos/axios";

export const desbloquearCidade = async (id: number): Promise<void> => {
  await apiDaInscricao().put(`/permissaoDasCidades/${id}/desbloquear`);
};
